<template>
  <div>
    <sweet-modal blocking :title="title" ref="modal" class="modal" v-on:close="closeModal('form')">
      <el-form :model="form" :disabled="onlyInfo" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="warehouseCode">
          <el-input :label="$t('settings_accountThink_inventory_warehouseCode')" v-model.trim="form.warehouseCode" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="warehouseName">
          <el-input :label="$t('settings_accountThink_inventory_warehouseName')" v-model="form.warehouseName" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="managerId">
          <el-select v-model="form.managerId" :placeholder="$t('settings_accountThink_inventory_contactForDeliveries')" filterable style="width: 100%">
            <el-option v-for="item in mangerList"
              :key="item.id"
              :label="item.fullName"
              :value="item.id"
              @click.native="autofillForManager(item)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="address">
          <el-input :label="$t('settings_accountThink_inventory_address')" v-model="form.address" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input :label="$t('settings_accountThink_inventory_mobile')" v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item prop="phone2">
          <el-input :label="$t('settings_accountThink_inventory_phone')" v-model="form.phone2"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input :label="$t('settings_accountThink_inventory_email')" v-model.trim="form.email"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item prop="buId">
              <el-select v-model="form.buId" placeholder="BU" filterable style="width: 100%" @change="() => {}">
                <el-option v-for="item in buList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="setProjectsList(item)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item prop="projectId">
              <el-select :disabled="!form.buId" v-model="form.projectId" placeholder="Project" clearable filterable style="width: 100%">
                <el-option v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item v-if="!onlyInfo">
          <div class="btn__space-between">
            <el-button disabled type="primary">Add Item Locations</el-button>
            <div v-if="isCreate">
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
            <div v-else>
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'create-update-modal',
    components: {
      SweetModal
    },
    data() {
      return {
        title: '',
        isCreate: true,
        row: null,
        onlyInfo: false,

        mangerList: [],
        buList: [],
        projectList: [],
        form: {
          warehouseCode: null,
          warehouseName: null,
          managerId: null,
          address: null,
          phone: null,
          phone2: null,
          email: null,
          buId: null,
          projectId: null,
        },

        rules: {
          warehouseCode: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          warehouseName: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          managerId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          address: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          buId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          email: [
            { required: false, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      setTitle() {
        if (this.onlyInfo) {
          this.title = 'Warehouse Details'
        } else {
          this.title = this.isCreate ? 'Add Warehouse' : 'Edit Warehouse'
        }
      },
      async openModal({ isCreate = true, row = {}, onlyInfo = false }) {
        this.onlyInfo = onlyInfo
        this.isCreate = isCreate
        this.setTitle()
        this.row = row
        await this.directories()
        if (!isCreate) {
          await this.handleEdit()
        }
        this.$refs.modal.open()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeModal(ref){
        this.$refs[ref].resetFields();
      },
      async directories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`api/v1/inventories/directories?companyId=${this.$route.query.companyId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.mangerList = data.list.managers
          this.buList = data.list.buList
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      addItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            try {
              this.checkEmptyLine()
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/inventories/create?companyId=${this.$route.query.companyId}`, this.form)
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async handleEdit() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`/api/v1/inventories/item?companyId=${this.$route.query.companyId}&id=${this.row.id}`)
          for (const key in this.form) {
            this.form[key] = data.inventory[key]
          }
          this.buList.forEach((item) => {
            if (item.id == this.form.buId) this.projectList = item.projects
          })
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      editItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            try {
              this.checkEmptyLine()
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/inventories/update?companyId=${this.$route.query.companyId}&id=${this.row.id}`, this.form)
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          }else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      autofillForManager(item) {
        this.form.phone = item.phone
        this.form.phone2 = item.workPhone
        this.form.email = item.email
      },
      setProjectsList(item) {
        this.form.projectId = null
        this.projectList = item.projects
      },
      checkEmptyLine() {
        if (this.form.projectId === "") this.form.projectId = null
        this.form.phone = this.form.phone ? this.form.phone : null
        this.form.phone2 = this.form.phone2 ? this.form.phone2 : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>